import { Directive, HostAttributeToken, inject, TemplateRef } from '@angular/core';

/**
 * Common table cell by group
 */
@Directive({
  selector: '[mbsTableCell]'
})
export class TableCellDirective {
  group = inject(new HostAttributeToken('group'), { optional: true });
  template = inject<TemplateRef<any>>(TemplateRef);
}
